export default "__VITE_ASSET__DSzIpzYg__"